module.exports = __webpack_public_path__ + "img/open_32.8fbad0ea.svg";